import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess({ packing_house_id, packing_house_process_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/show_inspect/packing_house_process/${packing_house_id}/${packing_house_process_id}`
    );
  },
  fetchExporterQualityTemplate({ packing_house_id, packing_house_process_id, packing_process_quality_template_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/show_inspect/quality_template/${packing_house_id}/${packing_house_process_id}/${packing_process_quality_template_id}`
    );
  },
  fetchExporterQualityInspect({ packing_house_id, packing_house_process_id, packing_process_quality_template_id, quality_inspect_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/show_inspect/quality_inspect/${packing_house_id}/${packing_house_process_id}/${packing_process_quality_template_id}/${quality_inspect_id}`
    );
  },
  fetchHarvestedBatch({ packing_house_id, packing_house_process_id, harvested_batch_id }) {
    return RequesterV1.get(
      `packing_house/quality_control/process/show_inspect/harvested_batch/${packing_house_id}/${packing_house_process_id}/${harvested_batch_id}`
    );
  },
  fetchExportQualityGroups({packing_house_id, packing_house_process_id, packing_process_quality_template_id}) {
    return RequesterV1.get(
      `packing_house/quality_control/process/show_inspect/export_quality_groups/${packing_house_id}/${packing_house_process_id}/${packing_process_quality_template_id}`
    );
  },
  destroy({ packing_house_id, packing_house_process_id, packing_process_quality_template_id, quality_inspect_id }) {
    return RequesterV1.delete(
      `packing_house/quality_control/process/show_inspect/destroy/${packing_house_id}/${packing_house_process_id}/${packing_process_quality_template_id}/${quality_inspect_id}`
    );
  },
};
